export const state = () => ({
  redirectUrl: "",
  pageTitle: ""
});

export const mutations = {
  SET_REDIRECT_URL(state, redirectUrl) {
    state.redirectUrl = redirectUrl;
  },
  SET_PAGE_TITLE(state, pageTitle) {
    state.pageTitle = pageTitle;
  }
};

export const actions = {};

export const getters = {};
